import { User } from '@/store/user/types';

export function generatePartnerUrl(urlSuffix: string, user: User | null): string {
	if (user?.enterprise?.name && user?.enterprise?.is_healthcare) {
		return `/${user.enterprise.name}-${urlSuffix}`;
	}
	return `/${urlSuffix}`;
}
